// Used for routeTracking.ts
export const WAITING_ROUTES = {
  ONE_TIME_TOKEN_LOGIN_WAITING: '/one-time-token-login',
  ACCOUNT_REPEATED_LOAN_WAITING: '/account/repeated-loan/check-details',
  FIRST_LOAN_MANUAL_UPLOAD_WAITING: '/first-loan/manual/upload/pending',
  FIRST_LOAN_ONLINE_BANK_PENDING_WAITING: '/first-loan/online-bank/pending', // here
  FIRST_LOAN_WAITING: '/first-loan/check',
  FIRST_LOAN_PHONE_VERIFICATION_WAITING: '/first-loan/phone-verification/check',
};

export const ROUTES = {
  // Anonymous:
  LOGIN: '/login',
  REGISTRATION_AFFILIATE: '/registration/affiliate',
  FIRST_LOAN: '/first-loan',
  FIRST_LOAN_MOBILE: '/first-loan-mobile',
  FIRST_LOAN_EMAIL: '/first-loan/email',
  FIRST_LOAN_CONFIRMATION: '/first-loan/confirmation',
  // Registration:
  FIRST_LOAN_WELCOME: '/first-loan/welcome',
  FIRST_LOAN_PERSONAL_DATA: '/first-loan/personal-data', // check atoms file before changing this route
  FIRST_LOAN_ADDRESS: '/first-loan/address',
  FIRST_LOAN_INCOME: '/first-loan/income',
  FIRST_LOAN_PHONE_VERIFICATION: '/first-loan/phone-verification',

  FIRST_LOAN_PHONE_VERIFICATION_CHANGE_PHONE:
    '/first-loan/phone-verification/change-phone',
  FIRST_LOAN_INCORRECT_CODE: '/first-loan/incorrect-code',
  FIRST_LOAN_REJECTED: '/first-loan/rejected',

  //// Online Bank:
  FIRST_LOAN_ONLINE_BANK_VERIFY: '/first-loan/online-bank/verify',
  FIRST_LOAN_ONLINE_BANK_VERIFY_NEW: '/first-loan/online-bank/tink',
  FIRST_LOAN_ONLINE_BANK_CHECK: '/first-loan/online-bank/check',
  FIRST_LOAN_ONLINE_BANK_TINK_WAITING: '/first-loan/online-bank/tink-waiting',
  FIRST_LOAN_ONLINE_BANK_APPROVED: '/first-loan/online-bank/approved',

  //////// Upload:
  FIRST_LOAN_ONLINE_BANK_ADD_DOCUMENTS: '/first-loan/online-bank/add-documents',
  FIRST_LOAN_ONLINE_BANK_IBAN: '/first-loan/online-bank/iban',
  // Rejections and errors
  FIRST_LOAN_ONLINE_BANK_REJECTED_BY_TINK:
    '/first-loan/online-bank/rejected-by-tink',
  FIRST_LOAN_ONLINE_BANK_REJECT: '/first-loan/online-bank/reject',
  FIRST_LOAN_ONLINE_BANK_ERROR: '/first-loan/online-bank/error',

  //// Manual:
  // Manual is either Upload (upload documents) or Email (user sends docs via email)
  FIRST_LOAN_MANUAL_UPLOAD: '/first-loan/manual/upload',
  FIRST_LOAN_MANUAL_UPLOAD_BANK_ACCOUNT:
    '/first-loan/manual/upload/bank-account',

  // Affiliate (identified customer):
  ACCOUNT_REPEATED_LOAN_CONFIRM: '/account/repeated-loan/confirm',
  ACCOUNT_REPEATED_LOAN_APPROVED_APPLICATION:
    '/account/repeated-loan/approved-application',
  ACCOUNT_REPEATED_LOAN_REJECTED_APPLICATION:
    '/account/repeated-loan/rejected-application',

  // Affiliate:
  AFFILIATE_PROVIDER_NAME: '/affiliate/:providerName',
  AFFILIATE_FIRST_LOAN_APPLICATION: '/affiliate/first-loan/application',

  // Payland
  PAYMENT_SUCCESS: '/payment-success',
  PAYMENT_FAILED: '/payment-failed',

  BEST_OFFER: '/best-offer',
  APPROVED: '/approved',

  FIRST_LOAN_TINK_BANK_NA: '/first-loan/tink/bank-na',
  FIRST_LOAN_TINK_BANK_ISSUE: '/first-loan/tink/bank-issue',
  FIRST_LOAN_TINK_LATER: '/first-loan/tink/later',
  REJECTED_TIMER: '/rejected/temporary-block',

  STELO_APPROVED: '/first-loan/stelo',
  STELO_REJECTED: '/stelo',
  STELO_REJECTED_TINK: '/stelo-tink',

  ...WAITING_ROUTES,
};
